import { render, staticRenderFns } from "./FilterUserTag.vue?vue&type=template&id=44c6e0fe"
import script from "./FilterUserTag.vue?vue&type=script&lang=js"
export * from "./FilterUserTag.vue?vue&type=script&lang=js"
import style0 from "./FilterUserTag.vue?vue&type=style&index=0&id=44c6e0fe&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c6e0fe')) {
      api.createRecord('44c6e0fe', component.options)
    } else {
      api.reload('44c6e0fe', component.options)
    }
    module.hot.accept("./FilterUserTag.vue?vue&type=template&id=44c6e0fe", function () {
      api.rerender('44c6e0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Segment/Components/FilterUserTag.vue"
export default component.exports